import {createSelector} from 'reselect';

import {isTeammateNamespace, isTeamNamespace} from '../../helpers/models/namespaceHelpers';
import {AppParametricSelector} from '../../helpers/reselectHelpers';
import {
  isSettingsPathItemMatchingPathId,
  makeSettingsItemFromLocationPathAndQuery,
  SettingsPathId,
} from '../../settings/menu/settingsHelpers';
import {getFlatTeams} from '../data/teams/teamsSelectors';

const personalSettingsWithoutNamespace: ReadonlyArray<SettingsPathId> = [
  'settings.notifications',
  'settings.profile',
  'settings.user-home',
];
const teamSettingsWithoutNamespace: ReadonlyArray<SettingsPathId> = [
  'settings.billing',
  'settings.deliverability',
  'settings.contactPreferences',
  'settings.integrations',
  'settings.teams',
  'settings.home',
  'settings.companyPreferences',
  'settings.tools',
];

export function makeGetSettingsTypeTrackingField<P>(
  getLocationPathAndQuery: AppParametricSelector<P, string>,
) {
  return createSelector([getLocationPathAndQuery, getFlatTeams], (locationPathAndQuery, teams) => {
    const settingsPathItem = makeSettingsItemFromLocationPathAndQuery(locationPathAndQuery);

    if (!settingsPathItem) {
      return undefined;
    }

    const namespace = settingsPathItem.parameters?.namespace || '';
    const onlyTeam = teams.length === 1 ? teams[0] : undefined;
    const isGlobalSetting = namespace === 'global';
    const isOnlyTeamSetting = onlyTeam ? namespace === onlyTeam.namespace : false;
    const isCompanySetting = isGlobalSetting || isOnlyTeamSetting;
    const isTeamSetting =
      isTeamNamespace(namespace) ||
      teamSettingsWithoutNamespace.some((pathId) =>
        isSettingsPathItemMatchingPathId(settingsPathItem, pathId),
      );
    const isPersonalSetting =
      isTeammateNamespace(namespace) ||
      personalSettingsWithoutNamespace.some((pathId) =>
        isSettingsPathItemMatchingPathId(settingsPathItem, pathId),
      );

    if (isCompanySetting) {
      return 'company';
    }
    if (isTeamSetting) {
      return 'team';
    }
    if (isPersonalSetting) {
      return 'personal';
    }

    return undefined;
  });
}
